
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12.425 5.67c-5.047 0-9.122 2.416-9.122 5.5s3.878 5.5 8.878 5.5v3.22h.744l4-4-4-4h-.744v2.78c-4 0-6.878-1.845-6.878-3.5s2.936-3.5 7.06-3.5c4.126 0 7.032 1.845 7.032 3.5 0 .78-.63 1.6-1.735 2.25l1.457 1.45c1.432-.971 2.304-2.261 2.304-3.7 0-3.084-3.95-5.5-8.996-5.5z","fill":"currentColor"}})])
          )
        }
      }
    